import { render, staticRenderFns } from "./Cn-Safety.vue?vue&type=template&id=167d1faa&"
import script from "./Cn-Safety.vue?vue&type=script&lang=js&"
export * from "./Cn-Safety.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports